import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { GetRoomReservationResponse } from '../../core/types/room-reservation-response.type';
import { CommonModule } from '@angular/common';
import { Guest } from '../../core/types/guest.type';
import { Facility } from '../../core/types/facility.type';
import { LOCALE_ID } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';
import { TranslateModule } from '@ngx-translate/core';
import { ReservationService } from '../../services/reservation.service';
import { Subscription } from 'rxjs';
import { FormArray, FormControl, FormGroup, FormGroupDirective, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { VehicleType } from '../../core/types/vehicle-type.enum';
import { ExtraField } from '../../core/types/property.type';
import { VehicleTypeOption, VehicleTypesEnum } from '../../core/types/vehicle.type';
import { ConfigResponse } from '../../core/types/config-response.type';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCar, faMotorcycle, faR, faTrailer } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-data-resumen',
  templateUrl: './data-resumen.component.html',
  styleUrls: ['./data-resumen.component.css'],
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, FontAwesomeModule],
  providers: [{ provide: LOCALE_ID, useValue: 'it-IT' }, FormGroupDirective],
})
export class DataResumenComponent implements OnInit, OnDestroy, OnChanges {
  @Input() reservation!: GetRoomReservationResponse | null;
  @Input() guest!: Guest | null;
  @Input() isForPdf = false;
  @Input() formGroup!: FormGroup;
  @Input() controlArray!: { name: string; type: string; control: FormControl }[];
  @Input() vehiclesFormArray!: FormArray<FormControl | FormGroup>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() formValues!: any;
  vehicleTypeOptions: VehicleTypeOption[] = [];
  guests: Guest[] = [];
  facilityIds: number[] = [];
  facilities: Facility[] = [];
  subscription = new Subscription();
  emailFromForm!: string;
  phoneFromForm!: string;
  plateFromForm!: string;
  JSON = JSON;
  vehicleTypes: { type: string; value: VehicleType }[] = [];
  selectsObject: {
    [key: string]: { type: string; value: VehicleType }[];
  } = {
    vehicleType: [],
  };
  extrafields: ExtraField[] = [];
  vehiclesFields = ['plate', 'vehicleType'];

  vehicleTypeIcons : { [key: string]: string } = {
    AUTO: 'fa-car',
    MOTO: 'fa-motorcycle',
    CAMPER: 'fa-rv',
    ROULOTTE: 'fa-trailer',
  };
  isMultipleVehiclesActive = false;

  constructor(
    private configurationService: ConfigurationService,
    private reservationService: ReservationService,
    private cd: ChangeDetectorRef
  ) {
    library.add(faCar, faMotorcycle, faR, faTrailer);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formValues'] && changes['formValues'].currentValue) {
      const fv = changes['formValues'].currentValue;
      this.emailFromForm = fv.email;
      this.phoneFromForm = fv.phone;
    }

    if (changes['reservation'] && changes['reservation'].currentValue) {
      const fv = changes['reservation'].currentValue;
      this.createVehicleTypeOptions(fv);
    }
    if (changes['guest'] && changes['guest'].currentValue) {
      const guest = changes['guest'].currentValue;
      this.emailFromForm = guest?.email || '';
      this.phoneFromForm = guest?.phone || '';
      this.plateFromForm = guest?.plate || '';
    }
    if (changes['controlArray'] && changes['controlArray'].currentValue) {
      const controlArray = changes['controlArray'].currentValue;
      controlArray.forEach((control: { name: string; }) => {
        if (control.name === 'plateCode') {
          this.vehiclesFields.push(control.name);
        }
        if (control.name === 'typeId') {
          this.vehiclesFields.push(control.name);
        }
      });
    }
    this.cd.detectChanges();
  }

  ngOnInit() {
    this.subscribetoConfig();
    this.subscribeToReservation();
    this.initVehicleTypes();
    this.selectsObject['vehicleType'] = this.vehicleTypes;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


  getVehicleIcon(type: string): string {
    switch (type.toLowerCase()) {
      case 'moto': return 'fa fa-motorcycle';
      case 'auto': return 'fa fa-car';
      case 'camper': return 'fa fa-shuttle-van'; // o 'fa-shuttle-van'
      case 'roulotte': return 'fa fa-trailer'; // alternativa: 'fa-caravan'
      default: return 'fa fa-question';
    }
  }

  getVehicleName(typeId: number): string {
    const vehicleType = this.vehicleTypes.find((v) => v.value === typeId);
    return vehicleType ? vehicleType.type[0].toUpperCase() + vehicleType.type.slice(1).toLowerCase() : '-';
  }

  private initVehicleTypes(): void {
    const vehicleTypesKeys = Object.keys(VehicleType) as Array<keyof typeof VehicleType>;
    this.vehicleTypes = vehicleTypesKeys
      .filter((value) => isNaN(parseInt(value)))
      .map((key) => ({ type: key, value: VehicleType[key] })) || [];

  }

  isFieldActive(fieldName: string): boolean {
    return this.extrafields.some(
      (extraField) => extraField.name?.toLowerCase() === fieldName.toLowerCase() && extraField.isVisible
    );
  }

  mustShowFields(control: { name: string }): boolean {
    return !control.name.includes('plateCode') && !control.name.includes('typeId');
  }

  subscribeToReservation() {
    this.subscription.add(
      this.reservationService.reservation$.subscribe((reservation) => {
        if (reservation) {
          this.guests = reservation.guests || [];
          this.facilityIds = this.reservation?.facilityIds || [];
        }
      })
    );
  }

  subscribetoConfig() {
    this.subscription.add(
      this.configurationService.config$.subscribe((config) => {
        if (config) {
          this.isMultipleVehiclesActive = !!config.vendor.allowedVehiclesCount || this.vehiclesFormArray.length > 0 || false;
          this.extrafields = config.vendor.extraFields || [];
          this.facilities = config.vendor.facilities || [];
        }
      })
    );
  }

  createVehicleTypeOptions(config: ConfigResponse) {
    if (config?.vehicleTypes?.length) {
      this.vehicleTypeOptions = config.vehicleTypes.map((vt: VehicleTypeOption) => ({
        id: vt.id,
        typeId: vt.typeId,
        name: vt.name
      }));
    } else {
      this.vehicleTypeOptions = Object.keys(VehicleTypesEnum)
        .filter((key) => isNaN(Number(key)))
        .map((key) => ({
          id: VehicleTypesEnum[key as keyof typeof VehicleTypesEnum],
          typeId: VehicleTypesEnum[key as keyof typeof VehicleTypesEnum],
          name: key.toUpperCase().trim()
        }));
      this.cd.detectChanges
    }
  }

  getFacilities(facilityIds: number[]): string {
    return facilityIds
      .map((facilityId) => this.facilities.find((facility) => facility.id === facilityId)?.text)
      .filter((x) => x)
      .join(', ');
  }

  isInvalid(control: AbstractControl | null): boolean {
    return !!control?.invalid && !!control?.errors && control.touched;
  }

  getFormControlErrorMessage(control: AbstractControl | null): string {
    if (!control) {
      return '';
    }
    if (control.hasError('required')) {
      return 'privacy_form.errors.required';
    }
    if (control.hasError('email')) {
      return 'privacy_form.errors.email';
    }
    if (control.hasError('pattern')) {
      return 'privacy_form.errors.pattern';
    }
    if (control.hasError('minLength')) {
      return 'privacy_form.errors.minLength';
    }
    if (control.hasError('phone')) {
      return 'privacy_form.errors.phone';
    }
    if (control.hasError('lettersAndNumbersOnly')) {
      return 'privacy_form.errors.lettersAndNumbersOnly';
    }
    if (control.hasError('plateCode')) {
      return 'privacy_form.errors.plateCode';
    }
    return 'No error message available';
  }
}
